import { useState } from 'react';

export default function CountertopsFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: 'What is the best countertop material for El Paso kitchens?',
      answer: 'Granite and quartz are both excellent choices for El Paso kitchens. Granite offers natural beauty and heat resistance, while quartz provides consistent patterns and low maintenance. Both materials perform well in El Paso\'s climate and are highly durable for daily kitchen use.'
    },
    {
      question: 'How much do granite countertops cost in El Paso?',
      answer: 'Granite countertops in El Paso typically cost $40-$100 per square foot installed, depending on the granite grade, color, and edge profile. Mid-range granite averages $50-$70 per square foot. Get quotes from multiple contractors to compare pricing and material options.'
    },
    {
      question: 'How long does countertop installation take?',
      answer: 'Countertop installation typically takes 1-3 weeks from templating to completion. This includes 1-2 weeks for fabrication after templating, and 4-6 hours for installation day. Timeline varies based on project complexity and contractor schedule.'
    },
    {
      question: 'Do I need to seal granite countertops?',
      answer: 'Yes, granite countertops should be sealed upon installation and resealed every 1-2 years to maintain stain resistance. Quartz countertops don\'t require sealing as they\'re non-porous. Your contractor can recommend the best sealing schedule for your specific granite.'
    },
    {
      question: 'Can countertops be installed over existing countertops?',
      answer: 'Generally, no. Old countertops should be removed to ensure proper installation and avoid structural issues. Removing old countertops allows contractors to inspect and repair cabinets if needed, ensuring your new countertops have a solid, level foundation.'
    },
    {
      question: 'What edge profiles are available for countertops?',
      answer: 'Common edge profiles include straight, beveled, bullnose, ogee, and waterfall edges. Each profile offers different aesthetics and pricing. Straight and beveled edges are most affordable, while decorative edges like ogee cost more due to additional fabrication work.'
    },
    {
      question: 'How do I maintain quartz countertops?',
      answer: 'Quartz countertops are low maintenance - simply clean with mild soap and water. Avoid harsh chemicals and abrasive cleaners. Quartz is non-porous and stain-resistant, making it ideal for busy kitchens. Use trivets for hot pans to prevent potential damage.'
    },
    {
      question: 'Are countertop warranties important?',
      answer: 'Yes, warranties are crucial. Look for contractors offering warranties on both materials (typically 10-25 years from manufacturer) and installation (1-5 years from contractor). Warranties protect your investment and ensure quality workmanship and materials.'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-xl text-gray-600">
            Common questions about countertop services in El Paso
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className="bg-gradient-to-br from-amber-50 to-white rounded-xl border-2 border-amber-100 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-8 py-6 flex items-center justify-between text-left hover:bg-amber-50 transition-colors"
              >
                <h4 className="text-lg font-bold text-gray-900 pr-8">
                  {faq.question}
                </h4>
                <i className={`ri-arrow-${openIndex === index ? 'up' : 'down'}-s-line text-2xl text-amber-700 flex-shrink-0`}></i>
              </button>
              {openIndex === index && (
                <div className="px-8 pb-6">
                  <p className="text-gray-700 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
